import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';

import DatePicker from '../../../../components/DatePicker';

const UploadedAdvancedFilters = ({
  uploadedDateRange,
  dateFormat,
  documentTypeOptions,
  selectedDocumentTypes,
  onUploadedDateRangeChange,
  onDocumentTypesChange,
}) => {
  const selectedDocumentTypeSet = new Set(selectedDocumentTypes);

  return (
    <div className="referral-filter-bar__row referral-filter-bar__row--secondary uploaded-records-filter-bar__secondary">
      <DatePicker.RangePicker
        className="referral-filter-bar__date-range"
        aria-label="Uploaded date range"
        placeholder={['Uploaded from', 'Uploaded to']}
        format={dateFormat}
        allowEmpty={[true, true]}
        value={uploadedDateRange}
        onChange={onUploadedDateRangeChange}
      />

      <div className="referral-filter-bar__toggles">
        {documentTypeOptions.map((option) => (
          <Tag.CheckableTag
            key={option.value}
            aria-label={option.label}
            className="referral-filter-bar__toggle"
            checked={selectedDocumentTypeSet.has(option.value)}
            onChange={(checked) => {
              const nextValues = checked
                ? [...selectedDocumentTypes, option.value]
                : selectedDocumentTypes.filter((value) => value !== option.value);
              onDocumentTypesChange(nextValues);
            }}
          >
            {option.label}
          </Tag.CheckableTag>
        ))}
      </div>
    </div>
  );
};

UploadedAdvancedFilters.propTypes = {
  uploadedDateRange: PropTypes.array.isRequired,
  dateFormat: PropTypes.array.isRequired,
  documentTypeOptions: PropTypes.array.isRequired,
  selectedDocumentTypes: PropTypes.array.isRequired,
  onUploadedDateRangeChange: PropTypes.func.isRequired,
  onDocumentTypesChange: PropTypes.func.isRequired,
};

export default UploadedAdvancedFilters;
